import React, { useRef, useState } from "react";
import { ImageBackground, PixelRatio, StyleSheet, TouchableOpacity, View, Text } from "react-native";
import { background } from "../../assets";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { useNavigation } from "@react-navigation/native";
import { useGlobalState } from "../../shared/state";
import { I18N } from "../../shared/util";
import { Styles } from "../../styles";

const NewScanUserOriginSelection: React.FC = (): JSX.Element => {
  const [, setRoute] = useGlobalState("currentScreen");
  const [currentScanner] = useGlobalState("currentScanner");
  const [, setUserOrigin] = useGlobalState("userOrigin");
  const [language] = useGlobalState("language");
  const [selectedRegion, setSelectedRegion] = useState(null);

  const i18n = I18N(language);
  const navigation = useNavigation();
  const isBirkenstock = currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock";

  const contienetsList = [
    {
      key: "north-america",
      text: i18n.t("newScan.north-america").toUpperCase(),
    },
    {
      key: "africa",
      text: i18n.t("newScan.africa").toUpperCase(),
    },
    {
      key: "south-america",
      text: i18n.t("newScan.south-america").toUpperCase(),
    },
    {
      key: "asia",
      text: i18n.t("newScan.asia").toUpperCase(),
    },
    {
      key: "europe",
      text: i18n.t("newScan.europe").toUpperCase(),
    },
    {
      key: "oceania",
      text: i18n.t("newScan.oceania").toUpperCase(),
    },
  ];

  const navigate = (route: string | undefined) => {
    if (route) {
      navigation.navigate(route);
      setRoute(route);
    }
  };

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onSelect = (choice: any) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setSelectedRegion(choice);
    setUserOrigin(choice);
    // navigate('NewScanModeSelection')
    timeoutRef.current = setTimeout(() => {
      navigate("NewScanUserBirthYear");
    }, 500);
  };

  return (
    <ImageBackground source={!isBirkenstock && background} style={Styles.backgroundImage} blurRadius={15}>
      <LayoutWrapper
        showHeaderCloseButton={false}
        showHeaderLogo={false}
        showMenuButtons={false}
        showStartButton={false}
        hideNewScanButton
        hideInfoButton
        title={i18n.t("newScan.origin")}
        showBirkenstockFooter = {isBirkenstock && true}
        showBirkenstockFooterLogo = {isBirkenstock && true}
        showBirkenstockHomeButton = {isBirkenstock && true}
      >
        <View style={styles.contentWrapper}>
          <View style={[styles.cardWrapper]}>
            {contienetsList.map((continent) =>
              isBirkenstock ? (
                <TouchableOpacity
                  key={continent.key}
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: selectedRegion === continent.key ? "#0e2288" : "#d1d3d4",
                    width: "45%",
                    height: "25%",
                    // marginHorizontal: "5%",
                    borderRadius: 12 / PixelRatio.get(),
                  }}
                  onPress={() => onSelect(continent.key)}
                >
                  <Text style={{ fontSize: 42, color: selectedRegion === continent.key ? "#ffffff" : "#555", fontWeight: "bold", fontFamily: "Birkentype" }}>{continent.text}</Text>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity
                  key={continent.key}
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#d1d3d4",
                    width: "30%",
                    height: "30%",
                    borderRadius: 12 / PixelRatio.get(),
                  }}
                  onPress={() => onSelect(continent.key)}
                >
                  <Text style={{ fontSize: 28, color: "#000000", fontWeight: "bold" }}>{continent.text}</Text>
                </TouchableOpacity>
              )
            )}
            {/* <TouchableOpacity style={{ position: 'absolute', top: '3%', }} onPress={onSelect}>
                        <Text style={styles.selectionCaption}>{i18n.t('newScan.select-origin')}</Text>
                    </TouchableOpacity> */}
            {/* <RadioButton data={contienetsList} onPress={onSelect} /> */}
          </View>
        </View>
      </LayoutWrapper>
    </ImageBackground>
  );
};

export default NewScanUserOriginSelection;

const styles = StyleSheet.create({
  backgroundImage: {
    resizeMode: "cover",
    flex: 1,
    backgroundColor: "white",
  },
  contentWrapper: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  cardWrapper: {
    flex: 1,
    minWidth: "60%",
    maxWidth: "70%",
    minHeight: "60%",
    maxHeight: "70%",
    paddingVertical: "1.5%",
    paddingHorizontal: "1.5%",
    marginTop: "-5%",
    backgroundColor: "#ffffff",
    opacity: 0.87,
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "space-around",
    shadowColor: "#000",
    shadowOffset: { width: 6 / PixelRatio.get(), height: 6 / PixelRatio.get() },
    shadowOpacity: 0.16,
    shadowRadius: 4 / PixelRatio.get(),
    elevation: 1,
  },
  selectionCaption: {
    fontFamily: "Montserrat-Black",
    fontSize: 21,
    color: "#3a3a3a",
    marginTop: "3.5%",
  },
});
